var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle",
                value: "list-invisible-filterjobs",
                expression: "'list-invisible-filterjobs'",
              },
            ],
            staticClass: "m-1",
            attrs: { variant: "info" },
          },
          [
            _c(
              "span",
              { staticClass: "when-open" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "chevron-up"] },
                }),
                _vm._v(" "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "when-closed" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "chevron-down"] },
                }),
                _vm._v(" "),
              ],
              1
            ),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("connector.label.list_filter_job")) +
                "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "b-collapse",
          {
            attrs: { id: "list-invisible-filterjobs" },
            model: {
              value: _vm.listVisible,
              callback: function ($$v) {
                _vm.listVisible = $$v
              },
              expression: "listVisible",
            },
          },
          [
            _c("b-table", {
              attrs: {
                fields: _vm.fields,
                items: _vm.filterJobs,
                small: "",
                responsive: "sm",
                "tbody-tr-class": _vm.rowClass,
              },
              scopedSlots: _vm._u([
                {
                  key: "cell(Id)",
                  fn: function (row) {
                    return [_c("b-col", [_vm._v(_vm._s(row.item.Id))])]
                  },
                },
                {
                  key: "cell(Libelle)",
                  fn: function (row) {
                    return [_c("b-col", [_vm._v(_vm._s(row.item.Name))])]
                  },
                },
                {
                  key: "cell(Include)",
                  fn: function (row) {
                    return [
                      _c(
                        "b-col",
                        [
                          _c("b-form-checkbox", {
                            attrs: { switch: "" },
                            on: {
                              input: function ($event) {
                                return _vm.updateFilterJob($event, row.item)
                              },
                            },
                            model: {
                              value: row.item.Include,
                              callback: function ($$v) {
                                _vm.$set(row.item, "Include", $$v)
                              },
                              expression: "row.item.Include",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }